import moment from "moment";

export default {
    data() {
        return {
            dateSplitUnits: [
                {value: -1, text: '不划分'},
                {value: 0, text: '年'},
                {value: 1, text: '季度'},
                {value: 2, text: '月'},
                {value: 3, text: '天'},
                {value: 4, text: '小时'},
                {value: 5, text: '分钟'},
                {value: 6, text: '秒'},
            ]
        }
    },
    methods: {
        getSplitDateArray(rows, dateFunc, unit) {
            let min = null;
            let max = null;
            this.forEachDate(rows, dateFunc, date => {
                if (!max || date > max) {
                    max = date;
                }
                if (!min || date < min) {
                    min = date;
                }
            })
            if (min && max) {
                return this.splitDateByUnit(min, max, unit);
            }
            return null;
        },
        splitDateByUnit(from, to, unit) {//unit: 0:year|1:quarter|2:month|3:day|4:hour|5:minute|6:second
            if (unit > 6 || unit < 0) {
                return;
            }
            let tempDate = this.beginOfDate(from, unit);
            let toDate = new Date(to);
            let result = [];
            while (tempDate <= toDate) {
                result.push(this.dateFormat(tempDate, unit));
                if (unit === 0) tempDate.setFullYear(tempDate.getFullYear() + 1);
                else if (unit === 1) tempDate.setMonth(tempDate.getMonth() + 3);
                else if (unit === 2) tempDate.setMonth(tempDate.getMonth() + 1);
                else if (unit === 3) tempDate.setDate(tempDate.getDate() + 1);
                else if (unit === 4) tempDate.setHours(tempDate.getHours() + 1);
                else if (unit === 5) tempDate.setMinutes(tempDate.getMinutes() + 1);
                else if (unit === 6) tempDate.setSeconds(tempDate.getSeconds() + 1);
            }
            return result;
        },
        beginOfDate(date, unit) {
            let tempDate = new Date(date);
            tempDate.setMilliseconds(0);
            if (unit < 6) tempDate.setSeconds(0);
            if (unit < 5) tempDate.setMinutes(0);
            if (unit < 4) tempDate.setHours(0);
            if (unit < 3) tempDate.setDate(1);
            if (unit < 2) tempDate.setMonth(Math.floor(tempDate.getMonth() / 3) * 3);
            if (unit < 1) tempDate.setMonth(0);
            return tempDate;
        },
        dateFormat(date, unit, needBeginOf = false) {//unit: 0:year|1:quarter|2:month|3:day|4:hour|5:minute|6:second
            if (unit > 6 || unit < 0) {
                return date;
            }
            let format = {
                0: 'YYYY',
                1: 'YYYY-MM',
                2: 'YYYY-MM',
                3: 'YYYY-MM-DD',
                4: 'YYYY-MM-DD HH:mm',
                5: 'YYYY-MM-DD HH:mm',
                6: 'YYYY-MM-DD HH:mm:ss'
            }
            if (needBeginOf) {
                date = this.beginOfDate(date, unit);
            }
            return moment(date).format(format[unit]);
        },

        isDate(str) {
            return isNaN(str) && /^\d/.test(str) && !isNaN(Date.parse(str));
        },
        forEachDate(rows, dateFunc, action) {
            for (let row of rows) {
                let date = dateFunc(row);
                if (this.isDate(date)) {
                    date = new Date(date);
                    action(date, row);
                }
            }
        },
        groupRowByDate(rows, dateFunc, unit) {
            let tempMap = {};
            this.forEachDate(rows, dateFunc, (date, row) => {
                let dateStr = this.dateFormat(date, unit, true);
                if (!tempMap.hasOwnProperty(dateStr)) {
                    tempMap[dateStr] = [];
                }
                tempMap[dateStr].push(row);
            })
            return tempMap;
        },
    }
}
